var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 4,
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M11.284 2.863c.777-1.296 2.655-1.296 3.432 0l.705 1.178a2 2 0 0 0 2.202.912l1.332-.334c1.465-.367 2.793.96 2.426 2.426l-.334 1.332a2 2 0 0 0 .912 2.202l1.178.705c1.296.777 1.296 2.655 0 3.432l-1.178.705a2 2 0 0 0-.912 2.202l.334 1.332c.367 1.465-.96 2.793-2.426 2.426l-1.332-.334a2 2 0 0 0-2.202.912l-.705 1.178c-.777 1.296-2.655 1.296-3.432 0l-.705-1.178a2 2 0 0 0-2.202-.912l-1.332.334c-1.465.367-2.793-.96-2.426-2.426l.334-1.332a2 2 0 0 0-.912-2.202l-1.178-.705c-1.296-.777-1.296-2.655 0-3.432l1.178-.705a2 2 0 0 0 .912-2.202l-.334-1.332c-.367-1.465.96-2.793 2.426-2.426l1.332.334a2 2 0 0 0 2.202-.912l.705-1.178Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b45874b47af14b4437f2a2ba726f02b5.svg";
export { ForwardRef as ReactComponent };